import './genesis.css'

export default (): void => {
  // Do nothing for now.
}
